import { useEffect, useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import useLocalStorageForOrganization from 'components/homepage/hooks/useLocalStorageForOrganization';
import { useCurrentProjectId } from 'hooks/path-params-extraction.hooks';
import { recentlyVisitedProjectIdsKey, recentlyVisitedProjectIdsLimit } from 'constants/local-storage.constants';

const useRecentlyVisitedProjects = () => {
  const currentProjectId = useCurrentProjectId();
  const [recentIds, setRecentIds] = useLocalStorageForOrganization<string[]>(recentlyVisitedProjectIdsKey);

  const recentProjectIds = useMemo(() => (Array.isArray(recentIds) ? recentIds : []), [recentIds]);

  useEffect(() => {
    if (currentProjectId) {
      const withoutCurrent = recentProjectIds.filter(id => id !== currentProjectId);
      const updatedRecentProjectIds = [currentProjectId, ...withoutCurrent].slice(0, recentlyVisitedProjectIdsLimit);

      if (!isEqual(updatedRecentProjectIds, recentProjectIds)) {
        setRecentIds(updatedRecentProjectIds);
      }
    }
  }, [currentProjectId, recentProjectIds, setRecentIds]);

  return recentProjectIds;
};

export default useRecentlyVisitedProjects;
